import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { cyan, slate } from './glowUtil'
import { DOT_PREFIX } from './constant'

const transition = 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)'

export default genComponentStyleHook(['Switch', 'techTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [`${componentCls}${DOT_PREFIX}`]: {
      transition,
      background: `${slate[700]} !important`,
      border: `1px solid ${cyan[500]}20`,

      [`&${componentCls}-checked`]: {
        background: `${cyan[500]}30 !important`,
        borderColor: `${cyan[500]}60`,
        boxShadow: `0 0 8px ${cyan[500]}30`,

        [`${componentCls}-handle:before`]: {
          background: `${cyan[500]} !important`,
          boxShadow: `0 0 6px ${cyan[500]}80`,
        },
      },

      [`${componentCls}-handle:before`]: {
        background: `${cyan[700]} !important`,
      },
    },
  }
})
